// import {v4 as uuid } from 'uuid';
import { isString, stringToArray } from '../../../../commons/utils/strings';

import {
    validateEmail,
 } from '../../../../commons/validations';

function fixColor (widget, propName) {
    if (widget[propName] && widget[propName].indexOf('#') === -1) {
        widget[propName] = `#${widget[propName]}`;
    }
}

function fixData (widget) {
    fixColor(widget, 'primary_button_background');
    fixColor(widget, 'button_background');
    fixColor(widget, 'button_foreground');
    fixColor(widget, 'header_background');
    fixColor(widget, 'header_foreground');
    fixColor(widget, 'horizontal_line_background');
    fixColor(widget, 'primary_button_foreground');
    fixColor(widget, 'secondary_button_background');
    fixColor(widget, 'secondary_button_foreground');

    if (!widget.banner_type) {
        widget.banner_type = 'solid';
        if (!widget.banner_colour) {
            widget.banner_colour = widget.primary_button_background;
        }
        widget.banner_url = '';
    };

    if (isString(widget.recommendations)) {
        widget.recommendations = stringToArray(widget.recommendations);
    }
}

async function showWidget (data) {
    const env = this.env;
    env.appStore.widget = data.widget;
    fixData(env.appStore.widget);
    await env.appStore.setupDynamicWidget(env.appStore.widget);
    console.log('showWidget() data: ', data);
    if (data.pageParams) {
        if (!validateEmail(data.pageParams.email)) {
            delete data.pageParams.email;
        }

        env.appStore.params = data.pageParams;

        if (env?.page?.params) {
            env.page.params = {
                ...env.page.params,
                ...data.pageParams,
            };
        }
        
        env.page = {
            ...env.page,
            params:  env.page.params,
        };
        console.log('showWidget() -> ', env.page);
    }
    env.appStore.launchWidget();
    /*
    env.appStore.oauthSessionId = null;
    // console.log('appClient.showWidget() ->  env.appStore.widget: ',  env.appStore.widget);
    env.appStore.observed.widget = uuid();
    env.appStore.init();
    env.appStore.kickstart();
    */
}

export default showWidget;
